import { render, staticRenderFns } from "./movieInfo.vue?vue&type=template&id=c7dfbb00&scoped=true&"
import script from "./movieInfo.vue?vue&type=script&lang=js&"
export * from "./movieInfo.vue?vue&type=script&lang=js&"
import style0 from "./movieInfo.vue?vue&type=style&index=0&id=c7dfbb00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7dfbb00",
  null
  
)

/* custom blocks */
import block0 from "./movieInfo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports